import React, { useContext, useEffect, useState } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { DatePicker, DateTimePicker, PrimaryButton, SecondaryButton, SelectBox, TextBox } from '../../../../Core/FormInput';
import { Button, ButtonGroup, Checkbox, Chip, Avatar, FormLabel, Grid, InputLabel, FormHelperText, Tooltip } from '@material-ui/core';
import {
    getTCards_ByID,
    getTCards_GetPartReqsByHeaderRecordID,
    getTCards_ScreenDropdown,
    postTCards_Delete,
    postTcardsAddUpdate,
    postTCardsLineItems_SwapSequence,
    postTCardsLock_Save,
    postTCardsLocks_ResetLock_Save
} from '../../../../Core/Service/checkInRole';
import formatters from '../../../../Core/Grid/inputFormatter';
import AddBoxIcon from '@material-ui/icons/AddBox';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import EditIcon from '@material-ui/icons/Edit';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import AppContext from '../../../../App/AppContext';
import DialogComp from '../../../../Core/Modal/dialogModal';
import HistoryTableModal from './historyModal';
import TcardNotesModal from './T-cardNotes/T-cardNotes';
import { useHistory } from 'react-router-dom';
import { SpeakerNotes, Link, Restore } from '@material-ui/icons';
import LinkTCardToJob from './linkTCardToJob';
import { useWindowSize } from '../../../../Core/Controls/ScreenResolution';
import moment from 'moment';
import { BiggerDisabledText } from '../../../../Core/FormInput/AppTextBox';
import Collected from './../../part_req_supplier/PartReturnStatus/Collected';
import ConfirmationModal from '../../../../Core/Controls/Dialog/ConfirmationModal';
import DeleteIcon from '@material-ui/icons/Delete';
import SearchTcardByReg from '../searchTcardByReg';
import LoanVehicleBooking from '../../loanVehicleBooking';
import DriveEtaTwoToneIcon from '@material-ui/icons/DriveEtaTwoTone';
import { ArrowDownwardRounded, ArrowUpwardRounded } from '@material-ui/icons';
import _uniqueId from 'lodash/uniqueId';
import TCardModalsBody from './tCardModalsBody';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import UpdateIcon from '@material-ui/icons/Update';
import BuildIcon from '@material-ui/icons/Build';
import { BreakdownFormSheet, PartReqSupplier, Service24Modal } from '../../..';
import AddcheckOut from '../T-Card_List/AddcheckOut';
import AddCheckIn from '../T-Card_List/AddCheckIn';
import ResetCheckInOut from '../T-Card_List/resetCheckInOut/resetCheckInOut';
import AddEditSiteVehicle from '../../Communicator/SiteVehicles/addEditSiteVehicle';

// import { temp } from '/locales/en/common.json';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: 'white',
        border: 'none',
        padding: '5px 10px'
    },
    body: {
        fontSize: 14,
        backgroundColor: 'white',
        border: 'none',
        padding: '5px 10px'
    }
}))(TableCell);

const StyledSubTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: 'white',
        borderBottom: '1px solid rgba(0,0,0,0.3)',
        padding: 5,
        fontSize: 11,
        fontWeight: 600
    },
    body: {
        fontSize: 14,
        backgroundColor: 'white',
        borderBottom: '1px solid rgba(0,0,0,0.3)',
        padding: 5
    }
}))(TableCell);

const StyledBlankTableCell = withStyles((theme) => ({
    body: {
        border: 'none'
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {}
}))(TableRow);

const legendItems = [
    {
        label: 'Loan Vehicle',
        background: 'blue',
        st: 'tCardsLoanVehicle'
    },
    {
        label: 'BreakDown',
        background: 'red',
        st: 'tCardIsBreakdown'
    },
    { label: 'C&D', background: '#bc6d1c', st: 'tCardsIsCollectionDeliver' },
    { label: 'Waiting', background: '#D32F2F', st: 'tCardsIsCustomerWaiting' },
    { label: 'Service', background: '#009eb9', st: 'tCardsIsService' },
    { label: 'Insp', background: '#833d36', st: 'tCardsIsInspection' },
    { label: 'MOT', background: '#1976D2', st: 'tCardsIsMOT' },
    { label: 'Break Test', background: '#1976D2', st: 'tCardsIsBrakeTest' },
    { label: 'Repair', background: '#11c446', st: 'tCardsIsRepair' },
    { label: 'Night', background: '#68095e', st: 'tCardsIsNightShift' },
    { label: 'Recall', background: '#68095e', st: 'tCardsIsRecallJob' },
    { label: 'Tacho', background: '#68095e', st: 'tCardsIsTacho' }
];

const useStyles = makeStyles({
    table: {
        minWidth: '100%'
    },
    table2: {
        maxWidth: '100%'
    },
    modalBackground: {
        zIndex: 5,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'top',
        opacity: 1,
        transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1)',
        padding: '0px 10px'
    },
    modalContainer: {
        maxWidth: '1280px'
    }
});

const TCardDashboardModal = (props) => {
    const classes = useStyles();
    let currentISOWeek = (date) => (date ? moment(date).isoWeek() : 'N/A');
    let borderCard = `4px solid ${props.tCardSelectedColor}`;
    const [isReload, setIsReload] = useState('');
    const history = useHistory();
    const { showToast, userRoles } = useContext(AppContext);
    const [btnLoader, setBtnLoader] = useState(false);
    const [selectedIndex, setSelectedInedx] = useState(null);
    const [warningMSG, setWarningMSG] = useState('');
    const [showTCardNotesModal, setShowTCardNotesModal] = useState(false);

    const [wd, height] = useWindowSize();

    const [state, setState] = React.useState({
        tCardsID: '',
        tCardsCustomerID: '',
        tCardsBranchID: '',
        tCardsVehicleID: '',
        tCardsRegistrationNumber: '',
        tCardsBookingDate: '',
        tCardsMOTLocation: '',
        tCardsMOTDate: '',
        tCardsDueDate: '',
        tCardsLoanVehicle: false,
        tCardIsBreakdown: false,
        tCardsIsCollectionDeliver: false,
        tCardsIsCustomerWaiting: false,
        tCardsStatusID: '',
        tCardsContactNumber: '',
        tCardsContactName: '',
        tCardsServiceAdvisorSignature: '',
        tCardsPaymentTypeID: '',
        tCardsMileage: '',
        tCardsHeaderRecordID: '',
        tCardsDeadlineDate: '',
        tCardsCustomerOrderNumber: '',
        tCardsCustomerSignature: '',
        tCardsCustomerName: '',
        tCardsAgentSignature: '',
        tCardsAgentName: '',
        tCardsIsService: false,
        tCardsIsBrakeTest: false,
        tCardsIsMOT: false,
        tCardsIsInspection: false,
        tCardsIsRepair: false,
        tCardsIsNightShift: false,
        tCardsCustomerPrintName: '',
        errors: {},
        customers: [],
        branches: [],
        payments: [],
        tCardLineStatus: [],
        tCardsEvents: [],
        tCardsStatus: [],
        tCardsTempEvents: [],
        TCardLineItems: [],
        customersContactList: [],
        tCardPrioritiesList: [],
        tCardsPriorityID: '',
        isRepair: false,
        showTcardHistoryPopup: false,
        showLinkJob: false,
        workflowID: null,
        processID: null,
        tCardsIsTacho: false,
        tCardsIsRecallJob: false,
        notesCount: 0,
        branchName: '',
        disabledUpdateButton: false,
        orderNumberRequired: false,
        wipNumber: null,
        smallSequence: null,
        bigSequence: null,
        tCardsMake: '',
        tCardsModel: '',
        vehicleStatus: '',
        tCardUnitRegNumber: '',
        tCardsDriverName: '',
        tCardsDriverContactNumber: ''
    });

    const [tCardItemList, setTCardItemList] = React.useState([]);

    const [checkTcard, setCheckTcard] = useState({
        showCheckout: false,
        tCardsID: null,
        bookingDate: null,
        selectedVehicle: null
    });

    let checkIsTcardReadonly = localStorage.getItem('_isTcardReadonly_') === 'true' ? true : false;

    const GetTCardData = async () => {
        if (props.id) {
            let res = await getTCards_ByID(props.id);
            if (res.success) {
                let data = res.data.tCards[0] || {};
                let newst = {};
                if (res?.data?.tCardsLineItems.length > 0) {
                    newst.smallSequence = res?.data?.tCardsLineItems?.reduce((acc, loc) =>
                        acc.tCardsLineItemSequence < loc.tCardsLineItemSequence ? acc : loc
                    ).tCardsLineItemSequence;
                    newst.bigSequence = res?.data?.tCardsLineItems?.reduce((acc, loc) =>
                        acc.tCardsLineItemSequence > loc.tCardsLineItemSequence ? acc : loc
                    ).tCardsLineItemSequence;
                }

                setState((st) => ({
                    ...st,
                    tCardsID: data.tCardsID,
                    tCardsBranchID: data.tCardsBranchID,
                    tCardsCustomerID: data.tCardsCustomerID,
                    tCardsVehicleID: data.tCardsVehicleID,
                    tCardsBookingDate: data.tCardsBookingDate ? formatters.DateFormatter(data.tCardsBookingDate) : '',
                    arrived: data.arrived,
                    collected: data.collected,
                    tCardsMOTLocation: data.tCardsMOTLocation,
                    tCardsMOTDate: data.tCardsMOTDate ? formatters.DateTimeTHMSFormatter(data.tCardsMOTDate) : '',
                    tCardsLoanVehicle: data.tCardsLoanVehicle,
                    tCardIsBreakdown: data.tCardIsBreakdown,
                    tCardsIsCollectionDeliver: data.tCardsIsCollectionDeliver,
                    tCardsIsCustomerWaiting: data.tCardsIsCustomerWaiting,
                    tCardsStatusID: data.tCardsStatusID,
                    tCardsContactNumber: data.tCardsContactNumber,
                    tCardsContactName: data.tCardsContactName,
                    tCardsServiceAdvisorSignature: data.tCardsServiceAdvisorSignature,
                    tCardsPaymentTypeID: data.tCardsPaymentTypeID,
                    tCardsDueDate: data.tCardsDueDate ? formatters.DateTimeTHMSFormatter(data.tCardsDueDate) : '',
                    tCardsMileage: data.tCardsMileage,
                    tCardsHeaderRecordID: data.tCardsHeaderRecordID,
                    tCardsPriorityID: data.tCardsPriorityID,
                    tCardsDeadlineDate: data.tCardsDeadlineDate ? formatters.DateTimeTHMSFormatter(data.tCardsDeadlineDate) : '',
                    tCardsCustomerOrderNumber: data.tCardsCustomerOrderNumber,
                    tCardsCustomerSignature: data.tCardsCustomerSignature,
                    tCardsCustomerName: data.tCardsCustomerName,
                    tCardsAgentSignature: data.tCardsAgentSignature,
                    tCardsAgentName: data.tCardsAgentName,
                    tCardsIsService: data.tCardsIsService,
                    tCardsIsBrakeTest: data.tCardsIsBrakeTest,
                    tCardsIsMOT: data.tCardsIsMOT,
                    tCardsIsNightShift: data.tCardsIsNightShift,
                    tCardsIsInspection: data.tCardsIsInspection,
                    tCardsIsRepair: data.tCardsIsRepair,
                    tCardsCustomerPrintName: data.tCardsCustomerPrintName,
                    tCardsRegistrationNumber: data.tCardsRegistrationNumber,
                    tCardsLineItems: res.data.tCardsLineItems,
                    workflowID: data.workflowID,
                    processID: data.processID,
                    tCardsIsTacho: data.tCardsIsTacho,
                    tCardsIsRecallJob: data.tCardsIsRecallJob,
                    notesCount: data.notesCount,
                    branchName: data.branchName,
                    orderNumberRequired: data.orderNumberRequired,
                    wipNumber: data.wipNumber,
                    tCardsCustomerAddress: data.tCardsCustomerAddress,
                    loanVehicleUsageRegistrationNumber: data.loanVehicleUsageRegistrationNumber,
                    dateIn: data.dateIn,
                    dateOut: data.dateOut,
                    loanVehicleID: data.loanVehicleID,
                    tCardsMake: data.tCardsMake || '',
                    tCardUnitRegNumber: data.tCardUnitRegNumber || '',
                    tCardsModel: data.tCardsModel || '',
                    vehicleStatusColour: data.vehicleStatusColour,
                    partReqHeaderRecordID: data.partReqHeaderRecordID,
                    vehicleStatus: data.vehicleStatus,
                    tCardsDriverName: data.tCardsDriverName,
                    tCardsDriverContactNumber: data.tCardsDriverContactNumber,

                    ...newst
                }));

                if (props.headerRecordID && props.isPartReq) {
                    fetchPartstHeaderRecordData(res?.data?.tCardsLineItems || []);
                } else {
                    setTCardItemList((res?.data?.tCardsLineItems || []).sort((a, b) => a.tCardsLineItemSequence - b.tCardsLineItemSequence));
                }
            }
        }
    };

    const fetchPartstHeaderRecordData = async (PreviousPartsList) => {
        if (props.headerRecordID && props.isPartReq) {
            try {
                const partReqRes = await getTCards_GetPartReqsByHeaderRecordID(props.headerRecordID);

                let tempData = [...PreviousPartsList];

                if (partReqRes.success) {
                    const partReqLineItems = partReqRes.data.partReqs.map((item) => ({
                        event: 'Repair',
                        isLocal: true,
                        tCardsLineItemSequence: '',
                        tCardsLineItemsAllocatedHours: '',
                        tCardsLineItemsDescription: item.pn,
                        tCardsLineItemsDueDate: '',
                        tCardsLineItemsEventTypeID: 4,
                        tCardsLineItemsID: null,
                        tCardsLineItemsLineStatusID: '',
                        tCardsLineItemsSpentHours: 0,
                        tCardsLineItemsTMV_ID: '',
                        tCardsLineItemsTCardsID: ''
                    }));

                    // Filter out duplicates based on description
                    const existingDescriptions = tempData.map((x) => x.tCardsLineItemsDescription);
                    const newItems = partReqLineItems.filter((item) => !existingDescriptions.includes(item.tCardsLineItemsDescription));

                    // Combine new items with existing list
                    const combinedData = [...tempData, ...newItems];

                    // Sort safely by sequence number (handle nulls or non-numeric)
                    const sortedData = combinedData.sort((a, b) => {
                        const seqA = parseInt(a.tCardsLineItemSequence) || 0;
                        const seqB = parseInt(b.tCardsLineItemSequence) || 0;
                        return seqA - seqB;
                    });

                    setTCardItemList(sortedData);
                }
            } catch (error) {
                console.error('Error fetching part requests:', error);
            }
        }
    };

    useEffect(() => {
        let setRes = false;
        const fetchData = async () => {
            if (props.id) {
                let res = await postTCardsLock_Save(props.id);
                setRes = res?.success;

                if (res.message) {
                    setWarningMSG(res?.message || 'T-Card Locked');
                    setState((st) => ({ ...st, showWarning: true, disabledUpdateButton: res?.message && true }));
                }
            }
        };

        fetchData();

        return () => {
            if (setRes && props.id) {
                postTCardsLocks_ResetLock_Save(props.id);
            }
        };
    }, []);

    useEffect(() => {
        GetTCardData();
    }, [props.id, isReload]);

    const hideConfirmationModal = () => {
        setWarningMSG('');
        setState((st) => ({ ...st, showWarning: false }));
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                let res = await getTCards_ScreenDropdown(props.id);
                setState((st) => ({
                    ...st,
                    customers: res.data.customer || [],
                    branches: res.data.branches || [],
                    payments: res.data.payment || [],
                    tCardLineStatus: res.data.tCardLineStatus || [],
                    tCardsEvents: res.data.tCardsEvent || [],
                    tCardsStatus: res.data.tCardsStatus || [],
                    tCardPrioritiesList: res.data.tCardPriorities || []
                }));

                if (props.selectedVehicle?.vehicleID) {
                    setState((st) => ({
                        ...st,
                        tCardsCustomerID: props.selectedVehicle.customerID || '',
                        tCardsCustomerName: props.selectedVehicle.customer || '',
                        tCardsBranchID: props.selectedVehicle.branchID || '',
                        tCardsVehicleID: props.selectedVehicle.vehicleID || '',
                        tCardsRegistrationNumber: props.selectedVehicle.reg || '',
                        tCardsStatusID: 1
                    }));
                }
            } catch (error) {
                console.error('Error fetching dropdown data:', error);
            }
        };

        fetchData();
    }, []);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (name === 'tCardsIsTacho' && checked) {
            setState((prev) => ({
                ...prev,
                tCardsTempEvents: prev.tCardsEvents.filter((x) => x.eventName == 'Tacho'),
                [name]: type === 'checkbox' ? checked : value,
                showJobPopup: true
            }));
        } else if (name === 'tCardsIsBrakeTest' && checked) {
            setState((prev) => ({
                ...prev,
                tCardsTempEvents: prev.tCardsEvents.filter((x) => x.eventName == 'Brake Test'),
                [name]: type === 'checkbox' ? checked : value,
                showJobPopup: true
            }));
        } else if (name === 'tCardsIsService' && checked) {
            setState((prev) => ({
                ...prev,
                tCardsTempEvents: prev.tCardsEvents.filter((x) => x.eventName == 'Service'),
                [name]: type === 'checkbox' ? checked : value,
                showJobPopup: true
            }));
        } else if (name === 'tCardsIsMOT' && checked) {
            setState((prev) => ({
                ...prev,
                tCardsTempEvents: prev.tCardsEvents.filter((x) => x.eventName == 'MOT'),
                [name]: type === 'checkbox' ? checked : value,
                showJobPopup: true
            }));
        } else if (name === 'tCardsIsInspection' && checked) {
            setState((prev) => ({
                ...prev,
                tCardsTempEvents: prev.tCardsEvents.filter((x) => x.eventName == 'Inspection'),
                [name]: type === 'checkbox' ? checked : value,
                showJobPopup: true
            }));
        } else if (name === 'tCardsIsRepair' && checked) {
            setState((prev) => ({
                ...prev,
                [name]: type === 'checkbox' ? checked : value,
                showJobPopup: true,
                isRepair: true
            }));
        } else {
            setState((prevState) => ({
                ...prevState,
                [name]: checked ? checked : value
            }));
        }
    };

    const handleButtonStatusClick = (statusKey, id) => {
        setState((prevState) => ({
            ...prevState,
            [statusKey]: id
        }));
    };

    const addRepairLine = () => {
        setState((prev) => ({ ...prev, showJobPopup: true, isRepair: true }));
    };

    const handleSelectedLineEventStatusChange = (e, index) => {
        const { name, value } = e.target;
        let tempList = [...tCardItemList];
        tempList[index][name] = value;
        setTCardItemList(tempList);
    };
    const handleLineEventChange = (e) => {
        const { name, value } = e.target;
        setState((prev) => ({ ...prev, [name]: value }));
    };
    const removeRepairLine = (index) => {
        let tempList = [...tCardItemList];
        tempList.splice(index, 1);
        setTCardItemList(tempList);
    };
    const editRowSelect = (index) => {
        setSelectedInedx(index);
    };

    const closeWarningModal = (res) => {
        setState((st) => {
            let newSt = { ...st };
            newSt.showJobPopup = false;
            newSt.showTcardHistoryPopup = false;
            newSt.selectedLineEventDesc = '';
            newSt.isRepair = false;
            return newSt;
        });
    };
    const closeLinkJobModal = (res) => {
        setState((st) => {
            let newSt = { ...st };
            newSt.showLinkJob = false;
            return newSt;
        });
        res && GetTCardData();
    };
    const handleHistoryModal = (res) => {
        setState((st) => {
            let newSt = { ...st };
            newSt.showTcardHistoryPopup = true;
            return newSt;
        });
    };
    const handleParts = (res) => {
        setState((st) => {
            let newSt = { ...st };
            newSt.showTcardParts = res;
            return newSt;
        });
    };
    const handelLinkJob = (res) => {
        if (state.tCardsHeaderRecordID) {
            window.open(`/Job/${state.tCardsHeaderRecordID}/${state.workflowID}?ProcessID=${state.processID}`, '_blank');
        } else {
            setState((st) => ({
                ...st,
                showLinkJob: true
            }));
        }
    };

    const handleLineEventSubmit = () => {
        // if (handleLineEventValidation()) {
        if (state.isRepair) {
            let tempList = [
                ...tCardItemList,
                {
                    tCardsLineItemsID: null,
                    tCardsLineItemstCardsID: '', /// need to check //...
                    tCardsLineItemsDescription: state.selectedLineEventDesc,
                    tCardsLineItemsEventTypeID: 4, /// need to check
                    tCardsLineItemsAllocatedHours: state.selectedLineEventAllHrs,
                    tCardsLineItemsSpentHours: 0,
                    tCardsLineItemsLineStatusID: '',
                    tCardsLineItemsDueDate: '',
                    tCardsLineItemsTMV_ID: '',
                    tCardsLineItemSequence: _uniqueId(),
                    isLocal: true,
                    event: 'Repair'
                }
            ];
            setTCardItemList(tempList);
            setState((prev) => ({
                ...prev,
                TCardLineItems: tempList,
                showJobPopup: false,
                selectedLineEventDesc: '',
                selectedLineEventAllHrs: '',
                selectedLineEvent: '',
                isRepair: false
            }));
        } else {
            let temp = state.tCardsTempEvents.find((x) => {
                return x.id == state.selectedLineEvent;
            });
            let tempList = [
                ...tCardItemList,
                {
                    tCardsLineItemsID: null,
                    tCardsLineItemstCardsID: '', /// need to check //...
                    tCardsLineItemsDescription: temp.name,
                    tCardsLineItemsEventTypeID: temp.tCardEventTypeID,
                    tCardsLineItemsAllocatedHours: temp.allocatedHours,
                    tCardsLineItemsSpentHours: 0,
                    tCardsLineItemsLineStatusID: '',
                    tCardsLineItemsDueDate: state.selectedLineEventDueDate || '',
                    tCardsLineItemsTMV_ID: '',
                    event: temp.eventName,
                    tCardsLineItemsPartReqID: temp.tCardsLineItemsPartReqID,
                    isLocal: true,
                    tCardsLineItemSequence: _uniqueId()
                }
            ];

            setTCardItemList(tempList);

            setState((prev) => ({
                ...prev,
                TCardLineItems: tempList,
                showJobPopup: false,
                selectedLineEventDesc: '',
                selectedLineEventAllHrs: '',
                selectedLineEvent: '',
                selectedLineEventDueDate: '',
                isRepair: false
            }));
        }
    };

    const validations = () => {
        const {
            tCardsMOTLocation,
            tCardsMOTDate,
            tCardsIsMOT,
            orderNumberRequired,
            tCardsCustomerOrderNumber,
            tCardsCustomerAddress,
            tCardsContactNumber,
            tCardsContactName,
            tCardsStatusID,
            tCardsBookingDate
        } = state;
        let formIsValid = true;
        let errors = {};

        if (tCardsIsMOT && (tCardsMOTLocation == null || tCardsMOTLocation == '')) {
            errors.tCardsMOTLocation = 'MOT Location is required';
            formIsValid = false;
        }
        if (tCardsIsMOT && (tCardsMOTDate == null || tCardsMOTDate == '')) {
            errors.tCardsMOTDate = 'MOT Date is required';
            formIsValid = false;
        }
        if (!tCardsStatusID == 0 && (tCardsBookingDate == null || tCardsBookingDate == '')) {
            errors.tCardsBookingDate = 'Booking Date is required';
            formIsValid = false;
        }
        if (orderNumberRequired && (tCardsCustomerOrderNumber == null || tCardsCustomerOrderNumber == '')) {
            errors.tCardsCustomerOrderNumber = 'This field is required';
            formIsValid = false;
        }
        if (tCardItemList.length == 0) {
            showToast('Please select at least one event.');

            formIsValid = false;
        }

        if (state.tCardsPaymentTypeID == 1) {
            if (!tCardsCustomerAddress) {
                errors.tCardsCustomerAddress = 'This field is required';
                formIsValid = false;
            }
            if (!tCardsContactNumber) {
                errors.tCardsContactNumber = 'This field is required';
                formIsValid = false;
            }
            if (!tCardsContactName) {
                errors.tCardsContactName = 'This field is required';
                formIsValid = false;
            }
        }
        setState((st) => ({ ...st, errors: errors }));
        return formIsValid;
    };

    const handleSubmit = async () => {
        if (validations()) {
            setBtnLoader(true);
            let data = {
                tCardsID: state.tCardsID,
                tCardsBranchID: state.tCardsBranchID,
                tCardsCustomerID: state.tCardsCustomerID,
                tCardsVehicleID: state.tCardsVehicleID,
                tCardsBookingDate: state.tCardsBookingDate,
                tCardsMOTLocation: state.tCardsMOTLocation,
                tCardsMOTDate: state.tCardsMOTDate,
                tCardsLoanVehicle: state.tCardsLoanVehicle,
                tCardIsBreakdown: state.tCardIsBreakdown,
                tCardsIsCollectionDeliver: state.tCardsIsCollectionDeliver,
                tCardsIsCustomerWaiting: state.tCardsIsCustomerWaiting,
                tCardsStatusID: state.tCardsStatusID,
                tCardsContactNumber: state.tCardsContactNumber,
                tCardsContactName: state.tCardsContactName,
                tCardsServiceAdvisorSignature: state.tCardsServiceAdvisorSignature,
                tCardsPaymentTypeID: state.tCardsPaymentTypeID,
                tCardsMileage: state.tCardsMileage,
                tCardsHeaderRecordID: state.tCardsHeaderRecordID,
                tCardsPriorityID: state.tCardsPriorityID,
                tCardsDeadlineDate: state.tCardsDeadlineDate,
                tCardsCustomerOrderNumber: state.tCardsCustomerOrderNumber,
                tCardsCustomerSignature: state.tCardsCustomerSignature,
                tCardsCustomerName: state.tCardsCustomerName,
                tCardsAgentSignature: state.tCardsAgentSignature,
                tCardsAgentName: state.tCardsAgentName,
                tCardsIsService: state.tCardsIsService || false,
                tCardsIsBrakeTest: state.tCardsIsBrakeTest || false,
                tCardsIsMOT: state.tCardsIsMOT || false,
                tCardsIsNightShift: state.tCardsIsNightShift || false,
                tCardsIsInspection: state.tCardsIsInspection || false,
                tCardsIsRepair: state.tCardsIsRepair || false,
                tCardsCustomerPrintName: state.tCardsCustomerPrintName,
                tCardsRegistrationNumber: state.tCardsRegistrationNumber,
                tCardLineItems: tCardItemList || [],
                tCardsIsTacho: state.tCardsIsTacho || false,
                tCardsIsRecallJob: state.tCardsIsRecallJob || false,
                tCardsDueDate: state.tCardsDueDate,
                tCardsCustomerAddress: state.tCardsCustomerAddress,
                tCardsMake: state.tCardsMake,
                tCardsModel: state.tCardsModel,
                tCardUnitRegNumber: state.tCardUnitRegNumber,
                tCardsDriverName: state.tCardsDriverName,
                tCardsDriverContactNumber: state.tCardsDriverContactNumber
            };

            try {
                let res = await postTcardsAddUpdate(data);
                if (res?.data?.success) {
                    showToast(res.data.message);
                    props.onClose(false, null, true);
                } else if (res.errors) {
                    for (const [key, value] of Object.entries(res?.errors)) {
                        showToast(`${key}: ${value}`);
                    }
                } else {
                    showToast(res.message);
                }
            } catch (error) {
                console.error('Error submitting form:', error);
                showToast('An error occurred while submitting the form.');
            }
            setBtnLoader(false);
        }
    };

    const handelDeleteTCard = (res) => {
        setState((st) => ({
            ...st,
            showDeleteWarning: true
        }));
    };

    const hideDeleteConfirmationModal = () => {
        setState((st) => ({ ...st, showDeleteWarning: false }));
    };

    const hideLoanVehicleModal = (res) => {
        setState((st) => ({ ...st, showLoanVehicleModal: false }));
        // res && GetTCardData();
    };

    const showLoanVehicleModal = () => {
        setState((st) => ({ ...st, showLoanVehicleModal: true }));
    };
    const hideBreakdownModal = (res) => {
        setState((st) => ({ ...st, showBreakdownModal: false }));
        // res && GetTCardData();
    };

    const showBreakdownModal = () => {
        setState((st) => ({ ...st, showBreakdownModal: true }));
    };

    const submitDeleteTCard = async () => {
        try {
            let res = await postTCards_Delete(state.tCardsID);
            if (res?.data?.success) {
                showToast(res.data.message);
                props.onClose(false, null, true);
            } else {
                showToast(res.message || 'Failed to update TCards');

                console.error('Failed to update TCards:', res);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            showToast('An error occurred while submitting the form.');
        }
    };
    const getRegValue = (val) => {
        if (val) {
            setState((st) => ({
                ...st,
                tCardsRegistrationNumber: val
            }));
        }
    };

    const handleRegDetails = (val, motObj) => {
        if (val) {
            setState((st) => ({
                ...st,
                tCardsCustomerID: val.customerID,
                tCardsBranchID: val.branchID,
                tCardsCustomerName: val.customer,
                tCardsRegistrationNumber: val.reg,
                tCardsModel: motObj.model,
                tCardsMake: motObj.make
            }));
        }
    };

    const handleSiteVehicle = () => {
        setState((st) => ({ ...st, siteVehicle: !st.siteVehicle }));
    };

    const RenderChecbox = () => {
        return (
            <Grid container spacing={2} justifyContent="space-between" alignContent="center">
                {legendItems.map((item, index) => {
                    return (
                        <Grid item>
                            <div>
                                <InputLabel shrink>
                                    <b>{item.label}</b>
                                </InputLabel>
                            </div>
                            <Grid container alignItems="center" spacing={1}>
                                <Checkbox
                                    checked={state[item.st]}
                                    onChange={handleChange}
                                    name={item.st}
                                    disabled={
                                        item.st == 'tCardsLoanVehicle'
                                            ? state.tCardsLoanVehicle == true && state.loanVehicleUsageRegistrationNumber
                                            : false || isReadonly
                                    }
                                />
                                {item.st == 'tCardsLoanVehicle' && (
                                    <span>
                                        {state.tCardsLoanVehicle && (
                                            <DriveEtaTwoToneIcon
                                                titleAccess="Loan Vehicle Details"
                                                style={{
                                                    paddingTop: '5px',
                                                    cursor: 'pointer',

                                                    color: state.dateIn
                                                        ? 'green'
                                                        : state.dateOut
                                                        ? 'red'
                                                        : state.loanVehicleUsageRegistrationNumber
                                                        ? 'blue'
                                                        : 'grey'
                                                }}
                                                onClick={showLoanVehicleModal}
                                            />
                                        )}
                                    </span>
                                )}
                                {item.st == 'tCardIsBreakdown' && (
                                    <span>
                                        {state.tCardIsBreakdown && state.tCardsHeaderRecordID && (
                                            <BuildIcon
                                                titleAccess="Breakdon Details"
                                                style={{
                                                    paddingTop: '5px',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={showBreakdownModal}
                                            />
                                        )}
                                    </span>
                                )}
                            </Grid>
                        </Grid>
                    );
                })}
            </Grid>
        );
    };

    const isTechnician = userRoles.includes('technician');

    let isReadonly = isTechnician ? true : false;

    const renderTitle = () => {
        return (
            <Grid container spacing={1}>
                <Grid item sm style={{ display: 'flex', alignContent: 'center', alignItems: 'center', gap: 10 }}>
                    <span>Update T-Card </span>
                    <span title={state.vehicleStatus == 'notarrived' ? 'Check In' : state.vehicleStatus == 'onsite' ? 'Check Out' : 'Off Site'}>
                        <DriveEtaIcon
                            style={{ color: state.vehicleStatusColour || 'grey', marginTop: 5, cursor: 'pointer' }}
                            onClick={
                                state.vehicleStatus == 'notarrived'
                                    ? () => handleCheckIn()
                                    : state.vehicleStatus == 'onsite'
                                    ? () => handleCheckout()
                                    : () => handleResetCheckInOut()
                            }
                        />
                    </span>
                    {state.tCardsHeaderRecordID && (
                        <span title={'Update vehicle status'}>
                            <UpdateIcon
                                style={{
                                    marginTop: 5,
                                    cursor: 'pointer'
                                }}
                                onClick={handleSiteVehicle}
                            />
                        </span>
                    )}
                </Grid>
                <Grid item>
                    {state.wipNumber && `WIP NO. - ${state.wipNumber}`}&nbsp;&nbsp;&nbsp;&nbsp; Week - {currentISOWeek(state.tCardsBookingDate)}
                </Grid>
                {randerChips()}
            </Grid>
        );
    };

    const RanderHeaderRow = () => {
        return (
            <Grid container spacing={2} justifyContent="flex-start">
                <Grid item xs={12} md={2}>
                    <SearchTcardByReg
                        isLabelShrink={true}
                        getRegValues={handleRegDetails}
                        value={state.tCardsRegistrationNumber}
                        getReg={getRegValue}
                        isError={true}
                        disabled={isReadonly}
                        isUpdate={true}
                        inputProps={{ style: { textTransform: 'uppercase' } }}
                    />
                </Grid>

                <Grid item xs={12} md={4}>
                    <InputLabel shrink error>
                        Customer
                    </InputLabel>
                    <TextBox name="tCardsCustomerName" value={state.tCardsCustomerName} onChange={handleChange} disabled={isReadonly} />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                    <InputLabel shrink style={{ marginBottom: '7px' }} error>
                        Payment Type
                    </InputLabel>
                    <SelectBox
                        fullWidth
                        name="tCardsPaymentTypeID"
                        value={state.tCardsPaymentTypeID}
                        onChange={handleChange}
                        List={state.payments || []}
                        disabled={isReadonly}
                    />
                </Grid>
                <Grid item xs={12} md={2}>
                    <InputLabel shrink>Make</InputLabel>
                    <TextBox name="tCardsMake" value={state.tCardsMake} onChange={handleChange} disabled={isReadonly} />
                </Grid>
                <Grid item xs={12} md={2}>
                    <InputLabel shrink>Unit Reg Number</InputLabel>
                    <TextBox name="tCardUnitRegNumber" value={state.tCardUnitRegNumber} onChange={handleChange} />
                </Grid>
                {state.tCardsPaymentTypeID == 1 && (
                    <Grid item xs={12}>
                        <InputLabel shrink error>
                            Customer Address
                        </InputLabel>
                        <TextBox name="tCardsCustomerAddress" value={state.tCardsCustomerAddress} onChange={handleChange} disabled={isReadonly} />
                        <FormHelperText error>{state.errors['tCardsCustomerAddress']}</FormHelperText>
                    </Grid>
                )}
            </Grid>
        );
    };

    const randerChips = () => {
        return (
            <Grid item>
                <Grid container alignItems="center" spacing={1} justifyContent="flex-end">
                    {!state.tCardsHeaderRecordID && (
                        <Grid item>
                            <Chip
                                style={{ marginRight: 7 }}
                                avatar={
                                    <Avatar>
                                        <DeleteIcon />
                                    </Avatar>
                                }
                                label={`Delete T-Card`}
                                onClick={handelDeleteTCard}
                            />
                        </Grid>
                    )}
                    <Grid item>
                        <Chip
                            style={{ marginRight: 7 }}
                            avatar={
                                <Avatar>
                                    <Link />
                                </Avatar>
                            }
                            label={`${state.tCardsHeaderRecordID ? 'Job Details' : 'Link Job'}`}
                            onClick={handelLinkJob}
                        />
                        <Chip
                            style={{
                                marginRight: 7,
                                color: state.notesCount > 0 ? 'white' : '',
                                backgroundColor: state.notesCount > 0 ? 'green' : ''
                            }}
                            avatar={
                                <Avatar>
                                    <SpeakerNotes
                                        style={{
                                            color: state.notesCount > 0 ? 'white' : '',
                                            backgroundColor: state.notesCount > 0 ? 'green' : ''
                                        }}
                                    />
                                </Avatar>
                            }
                            label={`Notes`}
                            onClick={() => setShowTCardNotesModal(true)}
                        />

                        <Chip
                            style={{ marginRight: 7 }}
                            avatar={
                                <Avatar>
                                    <Restore />
                                </Avatar>
                            }
                            label={`History`}
                            onClick={handleHistoryModal}
                        />
                        {state.partReqHeaderRecordID && (
                            <Chip
                                style={{ marginRight: 7 }}
                                avatar={
                                    <Avatar>
                                        <BuildIcon />
                                    </Avatar>
                                }
                                label={`Parts`}
                                onClick={() => handleParts(true)}
                            />
                        )}
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    const handleMoveClick = async (record, move) => {
        let switchRecord;
        let index = tCardItemList
            ?.map(function (e) {
                return e.tCardsLineItemsID;
            })
            .indexOf(record.tCardsLineItemsID);

        if (move == 'up') {
            switchRecord = tCardItemList[index - 1];
        }

        if (move == 'down') {
            switchRecord = tCardItemList[index + 1];
        }
        // const formID = PramDynamicFormID;
        const rec1 = record.tCardsLineItemsID;
        const rec2 = switchRecord.tCardsLineItemsID;

        const res = await postTCardsLineItems_SwapSequence(
            // formID,
            rec1,
            rec2
        ).then((res) => {
            if (res.success) {
                setIsReload(new Date());
                showToast(res.message || 'Operation failed');
            } else {
                showToast(res.message || 'Operation failed');
            }
        });
    };

    const handleCheckout = (row) => {
        setCheckTcard((s) => ({
            ...s,
            showCheckout: true
            // tCardsID: row.tCardsID,
            // selectedVehicle: row,
            // bookingDate: row.bd
        }));
    };

    const handleResetCheckInOut = (row) => {
        setCheckTcard((s) => ({
            ...s,
            showResetCheckInOut: true
            // tCardsID: row.tCardsID,
            // selectedVehicle: row,
            // bookingDate: row.bd
        }));
    };

    const handleCheckIn = (row) => {
        setCheckTcard((s) => ({
            ...s,
            showCheckIn: true
            // selectedVehicle: row,
            // tCardsID: row.tCardsID
        }));
    };
    const closeCheckout = (res) => {
        setCheckTcard((s) => ({
            ...s,
            showCheckout: false,
            tCardsID: null,
            bookingDate: null,
            showCheckIn: false,
            showResetCheckInOut: false,
            selectedVehicle: null
        }));

        res && setIsReload(new Date());
        res && props.onClose(false, null, true);
    };

    return (
        <div>
            {wd > 1480 ? (
                <div className={`${classes.modalBackground}`}>
                    <div className={classes.modalContainer}>
                        <TableContainer>
                            <Table className={classes.table2} aria-label="customized table">
                                <TableHead>
                                    <StyledTableRow style={{ borderTop: borderCard }}>
                                        <StyledTableCell colSpan={6} style={{ borderLeft: borderCard, borderRight: borderCard }}>
                                            <Grid container spacing={2} justifyContent="space-between">
                                                <Grid container justifyContent="space-between" alignItems="center" style={{ margin: '10px 5px 5px 5px' }}>
                                                    <Grid item xs={6}>
                                                        <Grid container alignItems="center" spacing={1} justifyContent="space-between">
                                                            <Grid item>
                                                                {' '}
                                                                <span
                                                                    style={{
                                                                        fontSize: 20,
                                                                        fontWeight: 600,
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: 10,
                                                                        justifyContent: 'space-between'
                                                                    }}
                                                                >
                                                                    <span>Update T-Card</span>
                                                                    <span
                                                                        title={
                                                                            state.vehicleStatus == 'notarrived'
                                                                                ? 'Check In'
                                                                                : state.vehicleStatus == 'onsite'
                                                                                ? 'Check Out'
                                                                                : 'Off Site'
                                                                        }
                                                                    >
                                                                        <DriveEtaIcon
                                                                            style={{
                                                                                color: state.vehicleStatusColour || 'grey',
                                                                                marginTop: 5,
                                                                                cursor: 'pointer'
                                                                            }}
                                                                            onClick={
                                                                                state.vehicleStatus == 'notarrived'
                                                                                    ? () => handleCheckIn()
                                                                                    : state.vehicleStatus == 'onsite'
                                                                                    ? () => handleCheckout()
                                                                                    : () => handleResetCheckInOut()
                                                                            }
                                                                        />
                                                                    </span>
                                                                    {state.tCardsHeaderRecordID && (
                                                                        <span title={'Update vehicle status'}>
                                                                            <UpdateIcon
                                                                                style={{
                                                                                    marginTop: 5,
                                                                                    cursor: 'pointer'
                                                                                }}
                                                                                onClick={handleSiteVehicle}
                                                                            />
                                                                        </span>
                                                                    )}
                                                                </span>
                                                            </Grid>
                                                            <Grid item>
                                                                {' '}
                                                                <span style={{ fontSize: 20, fontWeight: 600 }}>
                                                                    {state.wipNumber && `WIP NO. - ${state.wipNumber}`}
                                                                    &nbsp;&nbsp;&nbsp;&nbsp; Week - {currentISOWeek(state.tCardsBookingDate)}
                                                                </span>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    {randerChips()}
                                                    <Grid item>
                                                        <div
                                                            style={{ fontSize: 30, cursor: 'pointer', marginLeft: '-5px' }}
                                                            onClick={() => {
                                                                props.onClose(false, null, false);
                                                            }}
                                                        >
                                                            &times;
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    {RanderHeaderRow()}
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <RenderChecbox />
                                                </Grid>
                                            </Grid>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                    <TableRow>
                                        <StyledTableCell colSpan={6} style={{ borderLeft: borderCard, borderRight: borderCard }}>
                                            <Grid container spacing={1}></Grid>
                                        </StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <StyledBlankTableCell style={{ borderTop: borderCard }}>&nbsp;</StyledBlankTableCell>
                                        <StyledTableCell colSpan={4} style={{ borderLeft: borderCard, borderRight: borderCard, borderBottom: borderCard }}>
                                            <TCardModalsBody
                                                handleChange={handleChange}
                                                state={state}
                                                isReadonly={isReadonly}
                                                handleButtonStatusClick={handleButtonStatusClick}
                                                classes={classes}
                                                checkIsTcardReadonly={checkIsTcardReadonly}
                                                tCardItemList={tCardItemList}
                                                handleSelectedLineEventStatusChange={handleSelectedLineEventStatusChange}
                                                selectedIndex={selectedIndex}
                                                addRepairLine={addRepairLine}
                                                editRowSelect={editRowSelect}
                                                removeRepairLine={removeRepairLine}
                                                handleMoveClick={handleMoveClick}
                                                handleSubmit={handleSubmit}
                                                onClose={props.onClose}
                                                btnLoader={btnLoader}
                                            />
                                        </StyledTableCell>
                                        <StyledBlankTableCell style={{ borderTop: borderCard }}>&nbsp;</StyledBlankTableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            ) : (
                <DialogComp
                    maxWidth="lg"
                    onClose={() => {
                        props.onClose(false, null, false);
                    }}
                    overflow="auto"
                    fullWidth
                    title={renderTitle()}
                >
                    {' '}
                    <Grid container spacing={2} justifyContent="space-between">
                        <Grid item xs={12}>
                            {RanderHeaderRow()}
                        </Grid>
                        <Grid item xs={12}>
                            <RenderChecbox />
                        </Grid>
                    </Grid>
                    <TCardModalsBody
                        handleChange={handleChange}
                        state={state}
                        isReadonly={isReadonly}
                        handleButtonStatusClick={handleButtonStatusClick}
                        classes={classes}
                        checkIsTcardReadonly={checkIsTcardReadonly}
                        tCardItemList={tCardItemList}
                        handleSelectedLineEventStatusChange={handleSelectedLineEventStatusChange}
                        selectedIndex={selectedIndex}
                        addRepairLine={addRepairLine}
                        editRowSelect={editRowSelect}
                        removeRepairLine={removeRepairLine}
                        handleMoveClick={handleMoveClick}
                        handleSubmit={handleSubmit}
                        onClose={props.onClose}
                        btnLoader={btnLoader}
                    />
                </DialogComp>
            )}

            {state.showJobPopup ? (
                <DialogComp
                    title={state.isRepair ? 'Add Defect' : `Select Event`}
                    maxWidth="sm"
                    onClose={() => closeWarningModal(false)}
                    fullWidth
                    overflow="auto"
                >
                    <Grid container spacing={2} alignItems="flex-end">
                        {state.isRepair ? (
                            <>
                                <Grid item xs={12}>
                                    <FormLabel component="legend">Description</FormLabel>
                                    <TextBox
                                        fullWidth
                                        name="selectedLineEventDesc"
                                        value={state.selectedLineEventDesc}
                                        onChange={handleChange}
                                        autoFocus={true}
                                    />
                                    <FormHelperText style={{ color: 'red' }}>{state.errors['selectedLineEventDesc']}</FormHelperText>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormLabel component="legend">Allocated Hours</FormLabel>
                                    <TextBox fullWidth name="selectedLineEventAllHrs" value={state.selectedLineEventAllHrs} onChange={handleChange} />
                                    <FormHelperText style={{ color: 'red' }}>{state.errors['selectedLineEventAllHrs']}</FormHelperText>
                                </Grid>
                            </>
                        ) : (
                            <>
                                <Grid item xs={12}>
                                    <SelectBox
                                        onChange={handleLineEventChange}
                                        value={state.selectedLineEvent}
                                        name="selectedLineEvent"
                                        List={state.tCardsTempEvents || []}
                                    />
                                    <FormHelperText style={{ color: 'red' }}>{state.errors['selectedLineEvent']}</FormHelperText>
                                </Grid>
                                {/* {!props.headerRecordID && (
                                    <Grid item xs={12}>
                                        <DateTimePicker name="selectedLineEventDueDate" value={state.selectedLineEventDueDate} onChange={handleChange} />
                                    </Grid>
                                )} */}
                            </>
                        )}
                        <Grid item xs={12}>
                            <Button variant="contained" color="primary" fullWidth onClick={handleLineEventSubmit}>
                                Submit
                            </Button>
                        </Grid>
                    </Grid>
                </DialogComp>
            ) : null}
            {state.showTcardHistoryPopup && (
                <DialogComp title={'History'} maxWidth="md" onClose={closeWarningModal} fullWidth>
                    <HistoryTableModal tCardsID={state.tCardsID} />
                </DialogComp>
            )}
            {state.showLinkJob && (
                <DialogComp title={`Link Job`} maxWidth="lg" onClose={() => closeLinkJobModal(false)} overflow="auto" fullWidth>
                    <LinkTCardToJob
                        isReadOnly={checkIsTcardReadonly}
                        tCardsID={state.tCardsID}
                        branchName={state.branchName}
                        BranchID={state.tCardsBranchID}
                        CustomerName={state.tCardsCustomerName}
                        RegistrationNumber={state.tCardsRegistrationNumber}
                        onClose={closeLinkJobModal}
                    />
                </DialogComp>
            )}
            {showTCardNotesModal && (
                <TcardNotesModal
                    tCardsID={props.id}
                    onClose={(shouldRefresh = false) => {
                        setShowTCardNotesModal(false);
                        if (shouldRefresh) {
                            GetTCardData();
                        }
                    }}
                    maxWidth="md"
                    isReadOnly={checkIsTcardReadonly}
                />
            )}
            {state.showWarning ? (
                <DialogComp title="Warning" onClose={hideConfirmationModal} maxWidth="sm">
                    <ConfirmationModal
                        message={`${warningMSG}`}
                        // handleSubmit={submitFunction}
                        handleCancel={hideConfirmationModal}
                    />
                </DialogComp>
            ) : null}
            {state.showDeleteWarning ? (
                <DialogComp title="Warning" onClose={hideDeleteConfirmationModal} maxWidth="sm">
                    <ConfirmationModal
                        message={`Are you sure to delete this T-card?`}
                        handleSubmit={submitDeleteTCard}
                        handleCancel={hideDeleteConfirmationModal}
                    />
                </DialogComp>
            ) : null}
            {state.showLoanVehicleModal ? (
                <DialogComp title="Loan Vehicle Details" onClose={() => hideLoanVehicleModal(false)} maxWidth="xl" overflow="auto" fullWidth>
                    <LoanVehicleBooking tCardID={props.id} onClose={hideLoanVehicleModal} BranchID={state.tCardsBranchID} />
                </DialogComp>
            ) : null}
            {state.showBreakdownModal ? (
                <DialogComp title="Breakdown" onClose={() => hideBreakdownModal(false)} maxWidth="xl" overflow="auto" fullWidth>
                    <BreakdownFormSheet
                        onClose={hideBreakdownModal}
                        headerRecordID={state.tCardsHeaderRecordID}
                        BranchID={state.tCardsBranchID}
                        formModal={true}
                    />
                </DialogComp>
            ) : null}
            {state.showTcardParts ? (
                <DialogComp title="Parts Details" onClose={() => handleParts(false)} maxWidth="xl" overflow="auto" fullWidth>
                    <PartReqSupplier headerRecordID={state.partReqHeaderRecordID} />
                </DialogComp>
            ) : null}
            {checkTcard.showCheckout && (
                <DialogComp onClose={() => closeCheckout(false)} title={'Check-out Vehicle'} maxWidth="sm" fullWidth>
                    <AddcheckOut
                        tCardsID={state.tCardsID}
                        bookingDate={state.tCardsBookingDate}
                        selectedVehicle={{ arrived: state.arrived }}
                        onClose={closeCheckout}
                        hideHeader={true}
                    />
                </DialogComp>
            )}
            {checkTcard.showCheckIn && (
                <DialogComp onClose={() => closeCheckout(false)} title={'Check-In Vehicle'} maxWidth="sm" fullWidth>
                    <AddCheckIn tCardsID={state.tCardsID} selectedVehicle={checkTcard.selectedVehicle} onClose={closeCheckout} hideHeader={true} />
                </DialogComp>
            )}
            {checkTcard.showResetCheckInOut && (
                <DialogComp onClose={() => closeCheckout(false)} title={'Reset Dates'} maxWidth="sm" fullWidth>
                    <ResetCheckInOut tCardsID={state.tCardsID} arrived={state.arrived} collected={state.collected} onClose={closeCheckout} hideHeader={true} />
                </DialogComp>
            )}
            {state.siteVehicle ? (
                // <DialogComp title={addActionLogHeaderComp('Vehicle Status')} onClose={() => handleClose(false)} fullWidth maxWidth="lg">
                <AddEditSiteVehicle
                    onClose={handleSiteVehicle}
                    headerRecordID={state.tCardsHeaderRecordID}
                    reg={state.tCardsRegistrationNumber}
                    wip={state.wipNumber}
                    // isShowHistory={true}
                />
            ) : // </DialogComp>
            null}
        </div>
    );
};

export default TCardDashboardModal;
